// Вернуть ввод в строку сообщения текущего чата. Нужен после «быстрых»
// отправок (быстрые ответы через «/», скрипты, шаблоны из панели и ⌘K):
// фокус оставался на нажатой кнопке, и чтобы продолжить переписку, саппорт
// кликал в поле мышью. Ищем по data-атрибуту, а не по ref, потому что
// шаблоны отправляются и из компонентов вне ChatView. setTimeout — чтобы
// сработать после закрытия панели/палитры (они возвращают фокус себе).
export const focusChatComposer = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  window.setTimeout(() => {
    const textarea = document.querySelector<HTMLTextAreaElement>("textarea[data-chat-composer]");
    if (!textarea || textarea.disabled) {
      return;
    }
    textarea.focus();
    const end = textarea.value.length;
    textarea.setSelectionRange(end, end);
  }, 0);
};
